import { ChipGroup } from '@shared/components';
import { useMemo } from 'react';

export interface BlockedCourseChipGroupProps {
  examCourseInfos?: { code: string; name: string }[];
}

export default function BlockedCourseChipGroup(props: Readonly<BlockedCourseChipGroupProps>) {
  const { examCourseInfos } = props;

  const formattedLabels = useMemo(() => {
    return examCourseInfos?.map((course) => `${course.code} : ${course.name}`) ?? [];
  }, [examCourseInfos]);

  return (
    <ChipGroup
      labels={formattedLabels}
      limit={2}
      component='chip'
      slotProps={{
        wrapper: {
          sx: {
            flexDirection: 'column',
            alignItems: 'flex-start',
          },
        },
        elementsWrapper: {
          sx: (theme) => ({
            gap: theme.spacing(2),
          }),
        },
        chip: {
          size: 'medium',
          sx: {
            alignSelf: 'flex-start',
          },
        },
      }}
    />
  );
}
